/*
Hier wird nur inversify initialisiert.
Für gewöhnlich muss man an diese Datei nicht ran.
*/

import { Container, inject} from 'inversify';
import getDecorators from 'inversify-inject-decorators';
import { provide, fluentProvide, buildProviderModule  } from 'inversify-binding-decorators';
import 'reflect-metadata';

const rootContainer = new Container();
export const container = rootContainer.createChild();
export const { lazyInject, lazyInjectNamed, lazyInjectTagged, lazyMultiInject } = getDecorators(container);

const provideSingleton = (identifier: any) => {
    return fluentProvide(identifier)
    .inSingletonScope()
    .done(true);
};

const provideTransient = (identifier: any) => {
    return fluentProvide(identifier)
    .inTransientScope()
    .done(true);
};

export {inject, provide, provideSingleton, provideTransient, buildProviderModule};
export const loadContainer = function() {
    container.load(buildProviderModule());
};


